import React from 'react'

function CaseCreateFooter({ step, onBack, onContinue, onSubmit }) {
  const isLast = step === 5;

  return (
    <div className="flex items-center justify-end mt-8 pt-6 border-t border-[rgba(20,33,61,.1)] gap-2.5 font-plexsans">

      {step > 1 && (
        <button
          onClick={onBack}
          className="px-7 py-3.5 rounded-lg border-[1.5px] border-[rgba(20,33,61,.2)] bg-transparent text-[15px] font-semibold text-navy cursor-pointer hover:bg-[rgba(20,33,61,.04)] transition-colors"
        >
          ← Back
        </button>
      )}

      {!isLast ? (
        <button
          onClick={onContinue}
          className="px-8 py-3.5 rounded-lg border-none bg-tan text-[15px] font-semibold text-ivory cursor-pointer hover:bg-tanDark transition-colors"
        >
          Continue →
        </button>
      ) : (
        <button
          onClick={onSubmit}
          className="px-8 py-3.5 rounded-lg border-none bg-tanDark text-[15px] font-semibold text-ivory cursor-pointer hover:bg-navy transition-colors"
        >
          Submit case →
        </button>
      )}

    </div>
  );
}

export default CaseCreateFooter
